export default __webpack_public_path__ + "static/media/parkingmap4.244e2fa8.png";